export const NEW_ARRIVAL_URL =
  'https://commonthreads.com/collections/new-arrivals';

export const MEMBER_SUBSCRIPTION_STATUS = {
  ACTIVE: 'ACTIVE',
  PAUSED: 'PAUSED',
  CANCELLED: 'CANCELLED',
};
